import { EnvConstant } from 'src/configs/env.configs';
import { GoogleRecaptchaExecuteError } from 'src/errors';

export class GoogleRecaptchaService {
  async execute(action: 'register'): Promise<string> {
    try {
      return await window.grecaptcha.enterprise.execute(EnvConstant.GOOGLE_RECAPTCHA_SITE_KEY, { action });
    } catch (error: any) {
      throw new GoogleRecaptchaExecuteError(error?.message);
    }
  }
}

const googleRecaptchaService = new GoogleRecaptchaService();

export const getGoogleRecaptchaService = () => {
  return googleRecaptchaService;
};
